interface ParseIssuesPreviewProps {
	title: string;
	issues: string[];
	issueCount: number; // Count of issues not including title issue (ie. "Row # is not valid.").
	rowsWithIssueCount: number; //total number of rows with at least one issue
}

export default function ParseIssuesPreview({
	title,
	issues,
	issueCount,
	rowsWithIssueCount,
}: ParseIssuesPreviewProps) {
	if (issues.length < 1) return null;

	const isRowIssue = (value: string) => {
		if (value.toLocaleLowerCase().includes("row")) {
			return "font-medium";
		}

		return "ml-2 list-none";
	};

	return (
		<div
			className="rounded-b-lg border border-t-0 bg-white p-4"
			role="region"
			aria-label={`${title} preview`}>
			<h3 className="font-semibold">{title} Issues</h3>
			<p className="text-sm text-red-600">
				{issueCount} total issue{issueCount == 1 ? "" : "s"} over {rowsWithIssueCount} row
				{rowsWithIssueCount == 1 ? "" : "s"}
			</p>

			<ul className="mt-2 max-h-48 list-disc overflow-auto pl-4 text-sm">
				{issues.map((m, i) => (
					<li className={isRowIssue(m)} key={`${m}-${i}`}>
						{m}
					</li>
				))}
			</ul>
		</div>
	);
}
